import { CaseStudyLayout } from "../components/CaseStudyLayout";

const SECTIONS = [
  {
    title: "The problem",
    testid: "biopay-cs-problem",
    body: [
      "Everyday payments should be effortless. BioPay starts from a simple question: what if paying was as natural as being yourself?",
      "The concept focuses on making everyday payments more convenient, beginning where I live and study — campus environments.",
    ],
  },
  {
    title: "The concept",
    testid: "biopay-cs-concept",
    body: [
      "BioPay is a fintech concept exploring how biometric authentication could simplify payments and digital wallets.",
      "The idea explores connecting biometric authentication with payment experiences, using existing infrastructure as a possible starting point.",
    ],
  },
  {
    title: "Campus-first",
    testid: "biopay-cs-campus",
    body: [
      "Campuses already run on shared infrastructure — ID cards, canteens, stations where small payments happen constantly.",
      "BioPay explores the potential relationship between that existing campus infrastructure and digital wallets, turning a daily routine into a seamless payment experience.",
    ],
  },
  {
    title: "Feasibility and the development journey",
    testid: "biopay-cs-feasibility",
    placeholder: "product feasibility notes, technical exploration, and the journey so far",
  },
  {
    title: "The vision",
    testid: "biopay-cs-vision",
    body: [
      "A practical, user-friendly payment experience — one where authentication disappears into the background and paying simply happens.",
    ],
  },
  {
    title: "Product screenshots",
    testid: "biopay-cs-screenshots",
    placeholder: "real product screenshots and interface mockups",
  },
  {
    title: "MVP demonstration",
    testid: "biopay-cs-demo",
    placeholder: "a demonstration of the MVP once it is ready",
  },
];

const CaseStudyBioPay = () => (
  <CaseStudyLayout
    testid="case-study-biopay"
    number="01"
    category="Fintech · Startup · Biometric Payments"
    title="BioPay"
    headline="Exploring a more seamless way to pay."
    intro="A biometric payments and digital wallet concept focused initially on campus environments — with an emphasis on product feasibility, technical development, and working toward an MVP."
    sections={SECTIONS}
  />
);

export default CaseStudyBioPay;
